import { createJSONStorage, persist } from 'zustand/middleware';
import type { Organization } from '@/types';
import { create } from './customCreate';

interface OrganizationsState {
  organizations: Organization[];
  currentOrganization: Organization | null;
  setOrganizations: (organizations: Organization[]) => void;
  reset: () => void;
}

export const useOrganizationsStore = create<OrganizationsState>()(
  persist(
    (set, get, store) => ({
      organizations: [],
      currentOrganization: null,

      setOrganizations: (organizations) => {
        set({ organizations });

        // Refresh the current org from the new list so name updates take effect.
        // If the previously-selected id is no longer present (or none was selected),
        // fall back to the first org.
        const { currentOrganization } = get();
        const fresh = currentOrganization
          ? (organizations.find((o) => o.id === currentOrganization.id) ?? null)
          : null;
        set({ currentOrganization: fresh ?? organizations[0] ?? null });
      },

      reset: () => set(store.getInitialState()),
    }),
    {
      name: 'organizations-storage',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        organizations: state.organizations,
        currentOrganization: state.currentOrganization,
      }),
    },
  ),
);
